import { monthNames } from "../constants/monthNames";
export const fetchEMQXMonthlyCostData = async (token: string, year: number) => {
  if (!token) 
    return;
    try 
    {
      const response = await fetch(`https://wn69j49lhc.execute-api.us-east-2.amazonaws.com/prod/emqx-monthly-costs?year=${year}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        },
      });

      if (!response.ok) throw new Error("Failed to fetch API data");

     const jsonResponse = await response.json();
console.log("Raw API Response:", jsonResponse);

if (Array.isArray(jsonResponse))  
{
  const formattedData = (jsonResponse as Array<{
    month: string;
    year: string;
    cost: { PROD: number; QA: number; UAT: number };
  }>)
    .sort((a, b) => Number(a.month) - Number(b.month))
    .map((entry) => ({
      month: monthNames[parseInt(entry.month, 10) - 1] ?? entry.month,
      cost: {
        PROD: Math.round(entry.cost.PROD),
        QA: Math.round(entry.cost.QA),
        UAT: Math.round(entry.cost.UAT),
      },
    }));

  return formattedData;
  } 
  else 
  {
    console.error("Unexpected data format:", jsonResponse);
    return null;
  }

    }   
    catch (error) 
    {
        console.error("Error fetching API data:", error);
        return null;
    }
  };